import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import useDashboard from './useDashboard';

const HotJobs = () => {
    const { state } = useContext(SmartContext);
    const { getHotJobs } = useDashboard();

    useEffect(() => {
        getHotJobs();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.hotJobs))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <> 
            <div className="row g-3">
                {state?.data?.dashboardData?.hotJobs?.map((company: any, index: any) => {
                return (<>
                    <div className="col-sm-12">
                        <h3 className="font-16 font-600 mb-0">{company.title} @ {company.company}</h3>
                        <p className="font-14 font-400 mb-0">{company.applications} Applications | {company.views} Views</p>
                    </div>
                    

                    {index !== state?.data?.dashboardData?.hotJobs.length - 1 && (
                        <div className="col-12">
                            <hr className="m-0" />
                        </div>
                    )}
                </>)
                })}

            </div>
        </>
    );
};

export default HotJobs;
